import * as React from "react";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useCallback } from "react";
import { TimePicker } from "./TimePicker";
export var DateTimePicker = function (props) {
    var dateTimeFormat = props.dateTimeFormat, labelOK = props.labelOK, labelCancel = props.labelCancel, invalidDateMessage = props.invalidDateMessage, dateToSmallMessage = props.dateToSmallMessage, dateToBigMessage = props.dateToBigMessage, currentValue = props.currentValue, onDateTimeChange = props.onDateTimeChange, pastEnabled = props.pastEnabled, disabled = props.disabled;
    var onValueChange = useCallback(function (date, value) {
        var dateToPass = date;
        if (dateToPass == null)
            dateToPass = moment();
        onDateTimeChange(dateToPass, value);
    }, [onDateTimeChange]);
    var getDateTimeFormat = useCallback(function () {
        return dateTimeFormat || DefaultValues.DATE_TIME_FORMAT;
    }, [dateTimeFormat]);
    var getCurrentValue = useCallback(function () {
        return currentValue;
    }, [currentValue]);
    var getConfirmLabel = useCallback(function () {
        return labelOK || DefaultValues.LABEL_OK;
    }, [labelOK]);
    var getCancelLabel = useCallback(function () {
        return labelCancel || DefaultValues.LABEL_CANCEL;
    }, [labelCancel]);
    var getInvalidDateMessage = useCallback(function () {
        return invalidDateMessage || DefaultValues.INVALID_DATE_MESSAGE;
    }, [invalidDateMessage]);
    var getDateToSmallMessage = useCallback(function () {
        return dateToSmallMessage || DefaultValues.DATE_TO_SMALL_MESSAGE;
    }, [dateToSmallMessage]);
    var getDateToBigMessage = useCallback(function () {
        return dateToBigMessage || DefaultValues.DATE_TO_BIG_MESSAGE;
    }, [dateToBigMessage]);
    var getStyle = useCallback(function () {
        return DefaultValues.STYLE;
    }, []);
    return (React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
        React.createElement(KeyboardDateTimePicker, { format: getDateTimeFormat(), value: getCurrentValue(), onChange: onValueChange, okLabel: getConfirmLabel(), cancelLabel: getCancelLabel(), invalidDateMessage: getInvalidDateMessage(), minDateMessage: getDateToSmallMessage(), maxDateMessage: getDateToBigMessage(), disablePast: !pastEnabled, ampm: false, style: getStyle(), renderDay: pastEnabled ? (function (day, _selectedDate, _dayInCurrentMonth, dayComponent) {
                if (!(day === null || day === void 0 ? void 0 : day.isSameOrAfter(moment(), "day")))
                    return React.cloneElement(dayComponent, { style: { color: "rgba(0, 0, 0, 0.38)" } });
                return dayComponent;
            }) : undefined, disabled: !!disabled })));
};
var DefaultValues = /** @class */ (function () {
    function DefaultValues() {
    }
    DefaultValues.DATE_TIME_FORMAT = "DD.MM.YYYY, HH:mm";
    DefaultValues.LABEL_OK = "Speichern";
    DefaultValues.LABEL_CANCEL = "Abbrechen";
    DefaultValues.INVALID_DATE_MESSAGE = "Ungültiger Zeitpunkt";
    DefaultValues.DATE_TO_SMALL_MESSAGE = "Der Zeitpunkt liegt zu weit in der Vergangenheit";
    DefaultValues.DATE_TO_BIG_MESSAGE = "Der Zeitpunkt liegt zu weit in der Zukunft";
    DefaultValues.STYLE = {
        marginTop: 12
    };
    return DefaultValues;
}());
TimePicker.defaultProps = {
    disabled: false
};
//# sourceMappingURL=DateTimePicker.js.map